import { IThemeChanger } from '../entities';
import { generateStyles } from '../helpers/generateStyles';
import React from 'react';

const ThemeChanger = ({
	children,
	fontFamily,
	goldenColor,
	primaryColor,
	secondaryIconColor,
	backgroundColor,
	backgroundImage
}: IThemeChanger) => {
	const styles = React.useMemo(
		() =>
			generateStyles({
				fontFamily,
				goldenColor,
				primaryColor,
				secondaryIconColor,
				backgroundImage,
				backgroundColor
			}),
		[
			fontFamily,
			goldenColor,
			primaryColor,
			secondaryIconColor,
			backgroundImage,
			backgroundColor
		]
	);

	return (
		<>
			<style>{styles}</style>
			{children}
		</>
	);
};

export { ThemeChanger };
